import { get, post, put, remove, handleError } from '@/helpers/http';
import { Event } from 'jsk-shared';

export function getEvent(eventId: string) {
    return get(`/event/${eventId}`).then((e) => {
        const localEvent = e.data as Event;
        localEvent.eventdate = new Date(localEvent.eventdate);
        return localEvent;
    });
}

// returns the cache object e.g. {eventid: <Event object>}
export function getEvents() {
    return get(`/event`).then((e) => {
        const eventsData: any = e.data;

        for (const key in eventsData) {
            if (eventsData.hasOwnProperty(key)) {
                eventsData[key].eventdate = new Date(eventsData[key].eventdate);
            }
        }

        return eventsData;

    });
}

export function createEvent(newEvent: Event) {
    return post(`/event`, newEvent).then((e) => {
        return e.data.id as string;
    });
}

export function saveEvent(eventId: string, existingEvent: Event) {
    return put(`/event/${eventId}`, existingEvent).then((e) => {
        return e.data.id as string;
    });
}

export function deleteEvent(eventId: string) {
    return remove(`/event/${eventId}`);
}

export function deleteEventResults(eventId: string) {
    return remove(`/event/${eventId}/results`);
}

export function autoimport(eventId: string, reqUrl: string) {
    return post(`/event/${eventId}/results/autoimport`, { requrl: reqUrl }).then((e) => e.data);
}

export function validateResults(eventId: string, validateData: string) {
    return post(`/event/${eventId}/results/validate`, { data: validateData }).then((e) => e.data);
}

export function importResults(eventId: string, validateData: string) {
    return post(`/event/${eventId}/results/import`, { data: validateData }).then((e) => e.data);
}

//

export { handleError };
